export const avaliableDocTypes = {
  brochure: true,
  catalog: true,
  bulletin: true,
  seed: true,
  postcard: true, 
  poster: true
};



// WEBPACK FOOTER //
// ./src/components/App/config.ts